function buildStripePaymentElementBillingDetails(order) {
    if (!order) {
        return null;
    }

    var billingDetails = {};
    var displayName = ((order.Firstname || '') + ' ' + (order.Lastname || '')).trim();

    if (displayName) {
        billingDetails.name = displayName;
    }
    if (order.Email) {
        billingDetails.email = String(order.Email).trim();
    }
    if (order.Phone) {
        billingDetails.phone = String(order.Phone).trim();
    }

    var addr = {};
    if (order.Street) {
        addr.line1 = String(order.Street).trim();
    }
    if (order.Address2) {
        addr.line2 = String(order.Address2).trim();
    }
    if (order.Postalcode) {
        addr.postal_code = String(order.Postalcode).trim();
    }
    if (order.City) {
        addr.city = String(order.City).trim();
    }
    if (order.State) {
        addr.state = String(order.State).trim();
    }

    var country = order.Country ? String(order.Country).trim() : '';
    if (country.length === 2) {
        addr.country = country.toUpperCase();
    }

    if (Object.keys(addr).length > 0) {
        billingDetails.address = addr;
    }

    return Object.keys(billingDetails).length > 0 ? billingDetails : null;
}

function isDestroyedStripeElementError(error) {
    var message = error && error.message ? error.message : '';
    return message.indexOf('destroyed') >= 0;
}

function getStripe3AmountCentsFromCart(cart) {
    if (!cart) {
        return null;
    }

    var total = cart.TotalIncludingShippingCostsAndTaxAndDiscount;
    if (total == null || isNaN(total)) {
        total = cart.TotalIncludingShippingCosts;
    }

    if (total == null || isNaN(total)) {
        return null;
    }

    return Math.round(total * 100);
}

function attachStripe3PaymentElementHandlers(paymentElement) {
    if (!paymentElement || typeof paymentElement.on !== 'function') {
        return;
    }

    paymentElement.on('change', function (event) {
        var scope = angular.element(document.getElementById('app-shop')).scope();
        if (!scope) {
            return;
        }

        scope.stripe3SelectedPaymentMethodType = (event.value && event.value.type) ? event.value.type : null;
        if (typeof scope.onStripe3SelectedPaymentMethodTypeChanged === 'function') {
            scope.onStripe3SelectedPaymentMethodTypeChanged(scope.stripe3SelectedPaymentMethodType);
        }
        scope.$apply();
    });

    paymentElement.on('loaderror', function (event) {
        log(JSON.stringify(event));
        if (event.error != null && event.error.message != null && event.error.message.length > 0) {
            var scope = angular.element(document.getElementById('app-shop')).scope();
            if (!scope) {
                return;
            }

            scope.stripe3ErrorMessage = event.error.message;
            scope.$apply();
        }
    });
}

function createStripe3PaymentElementOptions(billingDetails) {
    var options = window.stripePaymentElementCreateOptions
        ? JSON.parse(JSON.stringify(window.stripePaymentElementCreateOptions))
        : {};

    if (billingDetails) {
        options.defaultValues = { billingDetails: billingDetails };
    }

    return options;
}

function mountStripe3PaymentElement(paymentElement) {
    if (!paymentElement || !document.getElementById('payment-element')) {
        return null;
    }

    window.stripePaymentElement = paymentElement;
    paymentElement.mount('#payment-element');
    attachStripe3PaymentElementHandlers(paymentElement);
    return paymentElement;
}

function reinitializeStripe3Elements(amountCents, billingDetails) {
    if (typeof stripe === 'undefined' || !window.stripe3ElementsOptions) {
        return null;
    }

    if (window.stripePaymentElement && typeof window.stripePaymentElement.unmount === 'function') {
        try {
            window.stripePaymentElement.unmount();
        } catch (e) {
            // Ignore unmount errors on already destroyed Elements.
        }
    }

    window.stripePaymentElement = null;

    var elementsOptions = Object.assign({}, window.stripe3ElementsOptions, { amount: amountCents });
    elements = stripe.elements(elementsOptions);
    window.elements = elements;

    var paymentElement = elements.create('payment', createStripe3PaymentElementOptions(billingDetails));
    mountStripe3PaymentElement(paymentElement);
    window.stripe3ElementsAmountCents = amountCents;
    return paymentElement;
}

function updateStripe3PaymentElementAmountIfNeeded(amountCents, billingDetails) {
    if (typeof amountCents !== 'number' || isNaN(amountCents)) {
        return null;
    }

    if (window.stripe3ElementsAmountCents === amountCents) {
        syncStripePaymentElementBillingDetailsFromDetails(billingDetails);
        return window.stripePaymentElement;
    }

    return reinitializeStripe3Elements(amountCents, billingDetails);
}

function syncStripePaymentElementBillingDetailsFromDetails(billingDetails) {
    window.stripePaymentElementBillingDetails = billingDetails;

    if (!billingDetails || !window.stripePaymentElement || typeof window.stripePaymentElement.update !== 'function') {
        return billingDetails;
    }

    try {
        window.stripePaymentElement.update({ defaultValues: { billingDetails: billingDetails } });
    } catch (error) {
        if (!isDestroyedStripeElementError(error)) {
            throw error;
        }
    }

    return billingDetails;
}

function syncStripePaymentElementBillingDetails(order) {
    if (typeof window === 'undefined') {
        return null;
    }

    return syncStripePaymentElementBillingDetailsFromDetails(buildStripePaymentElementBillingDetails(order));
}
